/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class CompanyDataFieldApi extends BaseApi {
  endPoint: string = '/api/admin/company-data-fields';
}
